window.addEventListener("DOMContentLoaded",  () => {
    const panelSearch = document.getElementById('search-sidebar-panel-content');
    const loader = panelSearch.querySelector('.loader');
    const searchFromSourceBar = document.getElementById('poi-source-search');
    const filterPoi = document.querySelector('.filter-poi');
    const autocompleteResult = panelSearch.querySelector('#autocomplete-result');
    const searchResultArea = panelSearch.querySelector('#poi-result');
    const articleResults = panelSearch.querySelector('#article-results');
    const articleList = panelSearch.querySelector('#article-list');
    const proximityLink = panelSearch.querySelector('#proximity');
    const exitProximityModal = document.getElementById('close-modal-proximity');
    const overlay = document.getElementById('overlay');
    const modalProximity = document.getElementById('modal-poi-proximity');
    const proximityLoader = modalProximity.querySelector('.nearby-loader');
    const spanKm = modalProximity.querySelector('#proximity-km');
    const addToRoadtrip = panelSearch.querySelector('#search-add-roadtrip');
    const addToBucketlist = panelSearch.querySelector('#search-add-bucketlist');

    searchFromSourceBar.addEventListener('submit', (e) => {
        e.preventDefault();
        openSearchPanelAndApplyFocusToSearch();
    });

    document.getElementById('poi-source-search-input').addEventListener('focus', (e) => {
        openSearchPanelAndApplyFocusToSearch()
    });

    const openSearchPanelAndApplyFocusToSearch = (e) => {
        searchFromSourceBar.classList.add('hidden')
        window.openSidebar();
        filterPoi.classList.toggle('collapsed');
        panelSearch.classList.add('open');
        panelSearch.querySelector('#sidebar-search-input').focus();
    }

    panelSearch.querySelector('#sidebar-search').addEventListener('submit', (e) => {
        e.preventDefault();
        loader.classList.add('visible');
        const searchQuery = panelSearch.querySelector('#sidebar-search-input').value.trim().toLowerCase()
        fetchAutoCompleteResults(searchQuery)
    });

    const fetchSearchResults = (id, title) => {
        const formData = new URLSearchParams();
        formData.append('id', id);
        formData.append('title', title);
        fetch(
            '/wp-json/lost-api/v1/poi-map-search', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                    'X-WP-Nonce': wpApiSettings.nonce
                },
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                loader.classList.remove('visible');
                displayResults(data.data)
            })
            .catch(e => {
                loader.classList.remove('visible');
                toastr.error('Une erreur est survenue');
                console.error(e);
                console.log('error fetching result');
            });
    };

    const fetchAutoCompleteResults = (query) => {
        const formData = new URLSearchParams();
        formData.append('query', query);
        fetch(
            '/wp-json/lost-api/v1/poi-search-autocomplete', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache'
                },
                body: formData
            })
            .then(response => response.json())
            .then(data => {
                loader.classList.remove('visible');
                displayAutoCompleteResults(data.data)
            })
            .catch(e => {
                loader.classList.remove('visible');
                toastr.error('Une erreur est survenue');
                console.log('error fetching result');
            });
    };

    autocompleteResult.addEventListener('click', (e) => {
        if (e.target.classList.contains('result-element')) {
            loader.classList.add('visible');
            fetchSearchResults(e.target.id, e.target.textContent);
            autocompleteResult.style.display = 'none';
        }
    })
    const displayAutoCompleteResults = (results) => {
        searchResultArea.style.display = 'none';
        articleResults.style.display = 'none';
        autocompleteResult.innerHTML = '';

        results.forEach(result => {
            const option = document.createElement("div");
            option.textContent = result.post_title;
            option.setAttribute('id', result.post_id);
            option.classList.add('result-element');
            autocompleteResult.appendChild(option);
        });
        autocompleteResult.style.display = 'flex';
    }

    const displayResults = (results) => {
        articleList.innerHTML = '';

        const poiResultTitle = searchResultArea.querySelector('#poi-result-title');
        const poiResultState = searchResultArea.querySelector('#poi-result-state');
        const poiResultButtons = searchResultArea.querySelector('#poi-result-buttons');
        const affiliationButton = poiResultButtons.querySelector('#affiliation-button-element');
        const affiliationLink = poiResultButtons.querySelector('#affiliation-link-element')

        proximityLink.setAttribute('data-fetched', "false");
        proximityLoader.classList.remove('hidden');

        if (results.poi === null) {
            poiResultTitle.textContent = 'No results found';
            poiResultState.textContent = '';
            poiResultButtons.style.display = 'none';
        } else {
            const poi = results.poi
            if (poi.poi_coords) {
                window.focusOnPoint(poi.poi_coords)
                window.openPopupOnCoords(poi.poi_coords);
            }
            poiResultTitle.textContent = poi.post_title;
            poiResultState.textContent = poi.state;
            poiResultButtons.style.display = 'grid';
            spanKm.textContent = poi.proximity_km

            if (poi.affiliation?.length > 0) {
                affiliationLink.setAttribute('href', poi.affiliation);
                affiliationButton.style.display = 'flex'
            } else {
                affiliationButton.style.display = 'none'
            }

            const proximityAttributes = {
                'data-km': poi.proximity_km,
                'data-id': poi.post_id,
            };

            const addToRoadtripAttributes = {
                'data-title': poi.post_title,
                'data-position': poi.poi_coords.lon + ',' + poi.poi_coords.lat,
            };

            window.setMultipleAttributesOnElement(proximityLink, proximityAttributes);
            window.setMultipleAttributesOnElement(addToRoadtrip, addToRoadtripAttributes);

            if (addToBucketlist && poi.in_bucket === '1') {
                addToBucketlist.classList.remove('poi-card-add-bucketlist')
                addToBucketlist.classList.add('poi-card-remove-bucketlist')
                addToBucketlist.querySelector('span').innerHTML = 'Retirer de ma bucket list'

                const addToBucketAttributes = {
                    'data-title': poi.post_title,
                    'data-thumbnail': poi.thumbnail,
                    'data-category': poi.main_category,
                    'data-state': poi.state,
                    'data-id': poi.post_id,
                    'data-grade': poi.grade,
                };

                window.setMultipleAttributesOnElement(addToBucketlist, addToBucketAttributes);
            }

            results.articles.forEach(article => {
                const articleItem = document.createElement('div');
                articleItem.classList.add('article');
                articleItem.innerHTML = getArticleTemplate(article);
                articleList.appendChild(articleItem);
            });
        }
        articleResults.style.display = 'block';
        articleList.style.display = 'block';
        searchResultArea.style.display = 'block';
    };

    proximityLink.addEventListener('click', async () => {
        modalProximity.classList.add('visible');
        overlay.classList.add('visible');

        if (proximityLink.getAttribute('data-fetched') === "false") {
            const poiId = proximityLink.getAttribute('data-id');
            const kms = proximityLink.getAttribute('data-km') || 100;

            await fetch('/wp-json/lost-api/v1/poi/by-kms/' + poiId + '/' + kms )
                .then(res => res.json())
                .then((res) => {
                    proximityLoader.classList.add('hidden');
                    if (res.data) {
                        const resultList = modalProximity.querySelector('#closest-poi-list');
                        res.data.forEach((poi) => {
                            resultList.insertAdjacentHTML(
                                "beforeend",
                                window.getProximityTemplate(poi)
                            );
                        })

                        proximityLink.setAttribute('data-fetched', "true");
                    }
                })
                .catch((error) => {
                    proximityLoader.classList.add('hidden');
                    toastr.error('Une erreur est survenue')
                    proximityLink.setAttribute('data-fetched', "true");
                });
        }
    });

    exitProximityModal.addEventListener('click', () => {
        modalProximity.classList.remove('visible');
        overlay.classList.remove('visible');
    });

    overlay.addEventListener('click', () => {
        modalProximity.classList.remove('visible');
        overlay.classList.remove('visible');
    });
});
